import { Trans } from '@lingui/macro'

import { useValidateOrderStatus } from '@contexts/ValidateOrderStatus/useValidateOrderStatus'
import { FooterScreen } from '@segments/ScreenLayout'
import { Result, Validating } from '@segments/Validation'
import * as React from 'react'

type TProps = NoChildren

/**
 * App screen used to validate the state of the order payment.
 * - Shows some loading UI while the BE is Qd for the info (that might take a while in this case):
 *    - if payment was successful redirects customer to the submitted screen,
 *    - otherwise shows error(s) & suggestions what to do next.
 * - It has to use the order & user from the URL params
 * because the customer will be directed here from the payment gateway (not from the other parts of the app).
 */
export const ValidatePaymentScreen: React.FC<TProps> = () => {
  const { isPrePaid, isFetching } = useValidateOrderStatus()

  const renderValidationMessage = () => {
    if (isFetching) {
      return <Validating message={<Trans>Validating the payment...</Trans>} />
    }

    if (isPrePaid) {
      return <Result type={`success`} heading={<Trans>Payment successful!</Trans>} />
    }

    return null
  }

  return (
    <FooterScreen display={`grid`} placeItems={`center`}>
      {renderValidationMessage()}
    </FooterScreen>
  )
}
